import axios from 'axios';

// API-Basis-URL (relativ für Produktion, absolut für Entwicklung)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Lädt die Formular-Konfiguration
 * GET /api/config.php
 */
export const getConfig = async () => {
  const response = await api.get('/config.php');
  return response.data;
};

/**
 * Schüler-Matching
 * POST /api/schueler/match.php
 *
 * @param {string} vorname
 * @param {string} nachname
 * @param {string} klasse
 */
export const matchStudent = async (vorname, nachname, klasse) => {
  const response = await api.post('/schueler/match.php', {
    vorname,
    nachname,
    klasse,
  });
  return response.data;
};

/**
 * Bestellung absenden
 * POST /api/bestellung.php
 *
 * @param {Object} orderData
 * @throws {Error} With user-friendly message from backend or default
 */
export const submitOrder = async (orderData) => {
  try {
    const response = await api.post('/bestellung.php', orderData);
    return response.data;
  } catch (error) {
    // Extrahiere Fehlermeldung vom Backend
    const errorMessage = error.response?.data?.error ||
                        error.response?.data?.message ||
                        error.message ||
                        'Bestellung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.';

    // Wirf einen Error mit der Nachricht für die UI
    throw new Error(errorMessage);
  }
};

export default api;
